import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { logJSError } from './utils/errFrontend';

// ==========================================
// GLOBAL ERROR HANDLERS
// ==========================================

window.addEventListener('error', (event) => {
  logJSError(event.message, event.filename || 'Unknown');
});

window.addEventListener('unhandledrejection', (event) => {
  logJSError(
    `Promise rejected: ${event.reason}`, 
    'Unhandled Promise'
  );
});

// ==========================================
// ESCALA AUTOMATICA DE LA INTERFAZ
// ==========================================
// Reduce toda la interfaz de forma pareja (zoom sobre <html>) cuando la
// ventana es mas chica que la referencia; nunca agranda. Se recalcula al
// redimensionar. El factor se publica en --ui-escala para que las medidas en
// vh/vw lo compensen y conserven su tamano real (compensarEscalaVh).
const ESCALA_REFERENCIA = { ancho: 1366, alto: 650 };
const ESCALA_MINIMA = 0.75;

const aplicarEscalaInterfaz = () => {
  const html = document.documentElement;
  // Se mide sin zoom para leer el tamano real de la ventana
  html.style.removeProperty('zoom');
  const factor = Math.max(
    ESCALA_MINIMA,
    Math.min(1, window.innerWidth / ESCALA_REFERENCIA.ancho, window.innerHeight / ESCALA_REFERENCIA.alto)
  );
  if (factor < 1) {
    html.style.zoom = String(factor);
    html.style.setProperty('--ui-escala', String(factor));
  } else {
    html.style.removeProperty('--ui-escala');
  }
};

aplicarEscalaInterfaz();
window.addEventListener('resize', aplicarEscalaInterfaz);

// ==========================================
// RENDER APP
// ==========================================

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);